import {Component, EventEmitter, Input, Output} from "@angular/core";
import {AppSearchFacet} from "../../../models/appSearch.model";

@Component(
        {
            selector: 'catalogue-app-search-facet',
            templateUrl: './app-search-facet.component.html'
        }
)
export class AppSearchFacetComponent {
    @Input() public facet: AppSearchFacet;
    @Output() public toggleFacetOption = new EventEmitter();

    public showAllOptions = false;

    get options() {
        if (this.showAllOptions) {
            return this.facet.options;
        }

        let options = [];

        let i = 0;
        for (let option of this.facet.options) {
            if (option.checked || i < 5) {
                options.push(option);
                i++;
            }
        }

        return options;
    }
}